import { render, staticRenderFns } from "./construct.vue?vue&type=template&id=1a25beba&scoped=true"
import script from "./construct.vue?vue&type=script&lang=js"
export * from "./construct.vue?vue&type=script&lang=js"
import style0 from "./construct.vue?vue&type=style&index=0&id=1a25beba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d97cc52897b1b5edd1ee8818c6a75fc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25beba",
  null
  
)

export default component.exports